import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './index.css';
import Root from './root';

ReactDOM.render(<Root />, document.getElementById('root'));
